import React, { Component } from "react";

import { connect } from "react-redux";
import { Lightbox } from "react-modal-image";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import CheckCircleOutlineTwoToneIcon from "@material-ui/icons/CheckCircleOutlineTwoTone";
import GridScrollQuantityBox from "../QuantityBoxes/GridScrollQuantityBox";
import { getDiscountedPrice } from "../../../../Helpers/promotions";
import dairyFreeIcon from "../../../ActionButton/assests/no-milk.png";
import glutenFreeIcon from "../../../ActionButton/assests/gluten-free.png";
import sugarFreeIcon from "../../../ActionButton/assests/sugar-free.png";
import nutFreeIcon from "../../../ActionButton/assests/peanut-free.png";
import organicIcon from "../../../ActionButton/assests/bio_480.png";
import vegetarianIcon from "../../../ActionButton/assests/leaf.png";
import veganIcon from "../../../ActionButton/assests/vegan.png";
import { getProductInventory } from "../../../../store/reducers/store";

import glutenIcon from "../../../ActionButton/assests/gluten.png";
import nutsSesameIcon from "../../../ActionButton/assests/nuts_sesame.png";
import dairyIcon from "../../../ActionButton/assests/dairy.png";
import eggIcon from "../../../ActionButton/assests/egg.png";
import seafoodShellfishIcon from "../../../ActionButton/assests/seafood_shellfish.png";
import chilliIcon from "../../../ActionButton/assests/chilli.png";
import { ReactComponent as Clock } from "../../../Menu/assets/alarm-clock.svg";
import { getPrepTime } from "../../../Menu/Helpers";
import { getCurrencyIcon } from "../../../../Helpers/currencyConverter";
function hexToRgb(hex) {
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  return result
    ? `rgba(${parseInt(result[1], 16)},${parseInt(result[2], 16)},${parseInt(
        result[3],
        16,
      )},0.2)
      `
    : null;
}

class ChoiceGridScroll extends Component {
  state = { zoomImage: false };
  handleOnClick = (
    isSelected,
    optionSelectedAmount,
    choiceSelectedAmount,
    quantity,
  ) => {
    if (this.state.zoomImage) return;
    const {
      choice,
      option,
      productUsedComponents,
      usedComponents,
      productQuantity,
      editedProduct,
      groupID,
      optionKey,
    } = this.props;
    let newQuantity = quantity;
    let resetOptions = false;

    if (!isSelected && optionSelectedAmount >= (option.maximum || Infinity)) {
      if (option.maximum === 1) resetOptions = true;
      else return;
    }

    if (isSelected) newQuantity = -choiceSelectedAmount;

    if (!isSelected && choice.related_product && choice.inventory !== null) {
      const totalUsedComponents = { ...usedComponents };

      Object.entries(editedProduct?.prevUsedComponents || {}).forEach(
        ([optionId, optionQuantity]) => {
          const newOptionId = optionId.toString().replace("Q", "");
          totalUsedComponents[newOptionId] =
            (totalUsedComponents[newOptionId] || 0) -
            optionQuantity *
              ((optionId.toString().includes("Q") && 1) ||
                editedProduct.quantity);
        },
      );
      Object.entries(productUsedComponents).forEach(
        ([productId, optionQuantity]) => {
          const newProductId = parseInt(productId.toString().replace("Q", ""));
          totalUsedComponents[newProductId] =
            (totalUsedComponents[newProductId] || 0) +
            optionQuantity *
              ((productId.toString().includes("Q") && 1) ||
                productQuantity.quantity);
        },
      );
      const choiceInventory = getProductInventory(
        choice.related_product,
        totalUsedComponents,
      );
      if (
        choiceInventory <
        ((option.quantity_exclusive && 1) || productQuantity.quantity)
      )
        return;
    }

    this.props.controlOptions(
      option,
      choice,
      newQuantity,
      groupID,
      resetOptions,
    );
  };
  zoomImage = (e) => {
    e.stopPropagation();
    this.setState({ zoomImage: true });
  };

  getIsOutOfStock = () => {
    const {
      usedComponents,
      editedProduct,
      choice,

      option,
    } = this.props;
    const totalUsedComponents = { ...usedComponents };
    return (
      !editedProduct?.options[option.id]?.selectedOptions?.[choice.id] && //Incase it was selected by the product before
      getProductInventory(choice.related_product, totalUsedComponents) <= 0
    );
  };
  NutritionalFacts() {
    const { choice, language, settings } = this.props;
    if (
      !settings.show_nutrition_facts ||
      !settings.show_nutrition_facts_products
    )
      return;
    let nut_en = "";
    let nut_ar = "";
    if (choice.calories && choice.calories > 0) {
      nut_en = nut_en + `Calories ${choice.calories}kcal / `;
      nut_ar = nut_ar + `السعرات الحرارية  ${choice.calories} سعرة حرارية / `;
    }
    if (choice.carbs && choice.carbs > 0) {
      nut_en = nut_en + `Carbs ${choice.carbs}g / `;
      nut_ar = nut_ar + `الكربوهيدرات ${choice.carbs}  جم / `;
    }
    if (choice.fats && choice.fats > 0) {
      nut_en = nut_en + `Fats ${choice.fats}g / `;
      nut_ar = nut_ar + `الدهون ${choice.fats} جم / `;
    }
    if (choice.protein && choice.protein > 0) {
      nut_en = nut_en + `Protein ${choice.protein}g`;
      nut_ar = nut_ar + `البروتين ${choice.protein}  جم `;
    }

    if (language === "arabic") {
      return nut_ar;
    }
    return nut_en;
  }

  render() {
    const {
      choice,
      option,
      settings,
      selectedOptions,
      themeColor,
      containerWidth,
      language,
      discountAmount,
      productQuantity,
      usedComponents,
      productUsedComponents,
      editedProduct,
      groupID,
      optionKey,
    } = this.props;

    const { zoomImage } = this.state;
    let selectedOption = selectedOptions[optionKey];
    const optionSelectedAmount = selectedOptions?.[optionKey]?.selected || 0;
    const choiceSelectedAmount =
      selectedOption?.selectedOptions?.[choice.id]?.quantity || 0;
    const isSelected = Boolean(choiceSelectedAmount);
    const choiceWidth = containerWidth / 2.5;

    const discountedPrice = getDiscountedPrice(
      choice.price,
      discountAmount,
      choice.modifier,
    );
    const has_striked_price =
      (choice.striked_price && choice.striked_price > choice.price) ||
      choice.price > discountedPrice;

    const isOutOfStock =
      (choice.inventory !== null && this.getIsOutOfStock()) ||
      choice?.related_product?.unavailable;
    const currencyIcon = getCurrencyIcon(settings);
    return (
      <div
        className={!isOutOfStock && !this.props.settings.is_menu && "pointer"}
        style={{
          position: "relative",
          opacity: (isOutOfStock && !zoomImage && 0.3) || 1,
        }}
        onClick={() => {
          !isOutOfStock &&
            !this.props.settings.is_menu &&
            this.handleOnClick(
              isSelected,
              optionSelectedAmount,
              choiceSelectedAmount,
              1,
            );
        }}
      >
        {zoomImage && (
          <div style={{ textAlign: "left" }}>
            <Lightbox
              hideDownload
              medium={choice.photo}
              large={choice.photo}
              alt={language === "arabic" ? choice.ar_value : choice.value}
              onClose={() => this.setState({ zoomImage: false })}
            />
          </div>
        )}
        <div
          className="m-auto"
          style={
            !isSelected
              ? {
                  position: "relative",
                  width: choiceWidth,
                  maxWidth: 180,
                  padding: 2,
                }
              : {
                  position: "relative",
                  width: choiceWidth,
                  maxWidth: 180,
                  border: `2px solid ${themeColor}`,
                  borderRadius: 10,
                  background: `linear-gradient(0deg, ${hexToRgb(
                    themeColor,
                  )}, ${hexToRgb(themeColor)})`,
                  padding: 0,
                }
          }
        >
          <img
            style={{
              mixBlendMode: "multiply",
              padding: 5,
              width: "100%",
              height: choiceWidth,
              maxHeight: 180,
              visibility: !choice.photo && "hidden",
              borderRadius: 10,
            }}
            src={choice.photo}
          />

          {isSelected ? (
            option.multiple ? (
              <GridScrollQuantityBox
                choiceSelectedAmount={choiceSelectedAmount}
                optionSelectedAmount={optionSelectedAmount}
                controlOptions={this.props.controlOptions}
                choice={choice}
                option={option}
                themeColor={themeColor}
                productQuantity={productQuantity}
                productUsedComponents={productUsedComponents}
                editedProduct={editedProduct}
                groupID={groupID}
                optionKey={optionKey}
              />
            ) : (
              <CheckCircleOutlineTwoToneIcon
                color={"white"}
                style={{
                  position: "absolute",
                  bottom: 20,
                  fontSize: 30,
                  borderRadius: "50%",
                  backgroundColor: "white",
                  left: "50%",
                  transform: "translate(-50%, 0)",
                  color: themeColor,
                }}
              />
            )
          ) : null}
          {choice.photo && (
            <ZoomInIcon
              onClick={this.zoomImage}
              style={{
                position: "absolute",
                top: 10,
                right: language !== "arabic" && 10,
                left: language === "arabic" && 10,
                color: themeColor,
                fontSize: 25,
                padding: 2,
                margin: !isSelected && 2,
                backgroundColor: "hsla(0,0%,100%,.8)",

                borderRadius: 5,
              }}
            />
          )}
        </div>

        <div
          className="my-2"
          style={{
            width: choiceWidth,
            maxWidth: 180,
            margin: "auto",
            direction: language === "arabic" ? "rtl" : "ltr",
          }}
        >
          {choice.preparation_time > 0 && settings.show_prep_times && (
            <>
              <Clock
                className="mx-2"
                style={{
                  width: "15px",
                  height: "15px",
                  fill: settings.dark,
                }}
              />
              <span style={{ color: this.props.themeColor }}>
                {getPrepTime(choice.preparation_time, language)}{" "}
              </span>
            </>
          )}
          {language === "arabic" ? choice.ar_value : choice.value}
          {settings.show_nutrition_facts && (
            <span
              className="mx-2"
              style={{
                textAlign: this.props.language === "arabic" ? "right" : "left",
              }}
            >
              {choice.dietary_restrictions?.includes("Dairy free") && (
                <img
                  src={dairyFreeIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {choice.dietary_restrictions?.includes("Gluten free") && (
                <img
                  src={glutenFreeIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {choice.dietary_restrictions?.includes("Sugar free") && (
                <img
                  src={sugarFreeIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {choice.dietary_restrictions?.includes("Nut free") && (
                <img
                  src={nutFreeIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {choice.dietary_restrictions?.includes("Vegan") && (
                <img
                  src={veganIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {choice.dietary_restrictions?.includes("Vegetarian") && (
                <img
                  src={vegetarianIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {choice.dietary_restrictions?.includes("Organic") && (
                <img
                  src={organicIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {choice.dietary_restrictions?.includes("Gluten") &&
                !choice.dietary_restrictions?.includes("Gluten free") && (
                  <img
                    src={glutenIcon}
                    alt="Gluten"
                    style={{ marginRight: 5, height: 17, width: 17 }}
                  />
                )}

              {choice.dietary_restrictions?.includes("Nuts/Sesame") && (
                <img
                  src={nutsSesameIcon}
                  alt="Nuts/Sesame"
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}

              {choice.dietary_restrictions?.includes("Dairy") && (
                <img
                  src={dairyIcon}
                  alt="Dairy"
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}

              {choice.dietary_restrictions?.includes("Egg") && (
                <img
                  src={eggIcon}
                  alt="Egg"
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}

              {choice.dietary_restrictions?.includes("Seafood/Shellfish") && (
                <img
                  src={seafoodShellfishIcon}
                  alt="Seafood/Shellfish"
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}

              {choice.dietary_restrictions?.includes("Chilli") && (
                <img
                  src={chilliIcon}
                  alt="Chilli"
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
            </span>
          )}
          {settings.show_nutrition_facts && this.NutritionalFacts() != "" && (
            <div>
              <span
                style={{
                  color: "#999",
                  fontSize: "12px",
                }}
              >
                {this.NutritionalFacts()}
              </span>
            </div>
          )}
          {/* {settings.show_nutrition_facts && (
            <div
              style={{
                textAlign: this.props.language === "arabic" ? "right" : "left",
              }}
            >
              {choice.dietary_restrictions?.includes("Dairy free") && (
                <img
                  src={dairyFreeIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {choice.dietary_restrictions?.includes("Gluten free") && (
                <img
                  src={glutenFreeIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {choice.dietary_restrictions?.includes("Sugar free") && (
                <img
                  src={sugarFreeIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {choice.dietary_restrictions?.includes("Nut free") && (
                <img
                  src={nutFreeIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {choice.dietary_restrictions?.includes("Vegan") && (
                <img
                  src={veganIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {choice.dietary_restrictions?.includes("Vegetarian") && (
                <img
                  src={vegetarianIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {choice.dietary_restrictions?.includes("Orgenic") && (
                <img
                  src={organicIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
            </div>
          )} */}

          <div
            style={{
              padding: 5,
              color: themeColor,
              textAlign: language === "arabic" ? "right" : "left",
              direction: language === "arabic" ? "rtl" : "ltr",
            }}
          >
            {has_striked_price && (
              <span
                className={`${(language === "arabic" && "ml-2") || "mr-2"}`}
                style={{ textDecoration: "line-through" }}
              >
                {`${
                  language === "arabic"
                    ? settings.currency_local
                    : settings.currency_english
                }
                ${Math.max(
                  choice.striked_price || -Infinity,
                  choice.price,
                )?.toFixed(settings.currency_decimals)}`}
              </span>
            )}
            <span>
              {choice.price > 0 && " + "}
              <span className={currencyIcon}>
                {choice.price
                  ? `${
                      language === "arabic"
                        ? settings.currency_local
                        : settings.currency_english
                    } ${Math.min(discountedPrice, choice.price)?.toFixed(
                      settings.currency_decimals,
                    )}`
                  : ""}
              </span>
            </span>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    settings: state.store.store.settings,
    language: state.store.language,
    categories: state.store.store.categories,
    usedComponents: state.store.used_components,
  };
};

export default connect(mapStateToProps)(ChoiceGridScroll);
